import { useSimulationStore } from '../../stores/useSimulationStore';
import styles from './Simulation.module.css';

export function TimelineView() {
  const result = useSimulationStore(s => s.result);
  const currentStep = useSimulationStore(s => s.currentStep);
  const jumpToStep = useSimulationStore(s => s.jumpToStep);

  if (!result || result.steps.length === 0) {
    return (
      <div style={{ padding: 12, fontSize: 12, color: 'var(--color-text-tertiary)' }}>
        No execution steps yet
      </div>
    );
  }

  return (
    <div className={styles.timeline}>
      <div className={styles.timelineTrack}>
        {result.steps.map((step, i) => {
          const isActive = i === currentStep;
          const isCompleted = i < currentStep;
          const isError = step.status === 'error';

          let dotClass = styles.stepDotIdle;
          if (isActive) dotClass = styles.stepDotActive;
          else if (isError) dotClass = styles.stepDotError;
          else if (isCompleted) dotClass = styles.stepDotCompleted;

          return (
            <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              {i > 0 && (
                <div className={`${styles.timelineConnector} ${isCompleted || isActive ? styles.timelineConnectorActive : ''}`} />
              )}
              <div
                className={`${styles.timelineStep} ${isActive ? styles.timelineStepActive : ''} ${isError ? styles.timelineStepError : ''}`}
                onClick={() => jumpToStep(i)}
                title={`Step ${i + 1}: ${step.operation}${step.error ? ` — ${step.error}` : ''}`}
              >
                <div className={`${styles.stepDot} ${dotClass}`} />
                <span className={styles.stepLabel}>{step.nodeType}</span>
              </div>
            </div>
          );
        })}
      </div>

      {/* Current step detail */}
      {currentStep >= 0 && currentStep < result.steps.length && (
        <div className={styles.stepDetail}>
          <div className={styles.stepDetailTitle}>
            Step {currentStep + 1}/{result.steps.length}: {result.steps[currentStep].operation}
          </div>
          {result.steps[currentStep].changes.map((c, i) => (
            <div key={i} className={styles.changeRow}>
              <span>{c.address === '__escrow__' ? 'Escrow' : c.address}</span>
              <span className={styles.changeArrow}>→</span>
              <span>{c.asset}</span>
              <span className={styles.changeArrow}>:</span>
              <span className={c.after > c.before ? styles.balanceIncrease : c.after < c.before ? styles.balanceDecrease : styles.balanceNeutral}>
                {c.before.toLocaleString()} → {c.after.toLocaleString()}
              </span>
            </div>
          ))}
          {result.steps[currentStep].error && (
            <div className={styles.errorDetail}>
              <strong>Error</strong>
              {result.steps[currentStep].error}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
